/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { AnchorPoint, BendablePlate, BoltHole, CamlockHole, CornerBoltHoles, CornerCountersinkHoles, CountersinkHole, CustomBend, DeadboltHole, EuroCylinderHoleAu, EuroCylinderHoleEu, Hole, Hole54, KickPlate, KickPlateBoltHoles, KickPlateBulkOrderItem, KickPlateCountersinkHoles, OvalCylinderHole, PD7Hole, PN6Hole, PlainCylinderHole, PlainLocksetHole, Plate, RectangularHole, RectangularPlate, RimCylinderHole, RoundPlate, SquareHole, SquarePlate, StrikeBend, StrikePlate } from './model/index.js';
export const constants = {
    Plate: {
        $conflictingFeatureDistance: 3,
        $powderCoatingMinHoleSize: 6,
        $minLength: 10
    },
    Hole: {
        $defaultCornerOffset: 20
    },
    BoltHole: {
        $holeType: 'bolt'
    },
    PlainCylinderHole: {
        $holeType: 'custom_cylinder'
    },
    RimCylinderHole: {
        $holeType: 'rim_cylinder'
    },
    Hole54: {
        $holeType: '54mm_lockset'
    },
    DeadboltHole: {
        $holeType: 'deadbolt_lockset'
    },
    PlainLocksetHole: {
        $holeType: 'custom_lockset'
    },
    CountersinkHole: {
        $holeType: 'countersink'
    },
    CamlockHole: {
        $holeType: 'camlock_cylinder'
    },
    EuroCylinderHoleAu: {
        $holeType: 'euro_cylinder'
    },
    EuroCylinderHoleEu: {
        $holeType: 'euro_cylinder'
    },
    OvalCylinderHole: {
        $holeType: 'oval_cylinder'
    },
    PN6Hole: {
        $holeType: 'PN6_lockset'
    },
    PD7Hole: {
        $holeType: 'PD7_lockset'
    },
    RectangularHole: {
        $holeType: 'rectangle'
    },
    SquareHole: {
        $holeType: 'square'
    },
    CornerCountersinkHoles: {
        $holeType: 'countersink'
    },
    KickPlateCountersinkHoles: {
        $holeType: 'countersink'
    },
    CornerBoltHoles: {
        $holeType: 'bolt'
    },
    KickPlateBoltHoles: {
        $holeType: 'bolt'
    },
    KickPlate: {
        $minHorizontalLength: 400,
        $minVerticalLength: 100
    }
};
const KickPlateFixingHolesExpressions = [
    '$availableHorizontalHoleCountOptions',
    '$availableVerticalHoleCountOptions',
    '$horizontalCount',
    '$verticalCount'
];
const AnchorableShapeExpressions = [
    '$absCoords',
    '$anchorableShapesChain',
    '$boundingBox',
    '$center',
    '$padding',
    '$hiddenAnchorPoints',
    '$anchorPoints'
];
const AnchorPointExpressions = [
    '$absCoords',
    '$absCoords3D',
    '$relCoords',
    '$visible',
    '$shape',
    '$plate'
];
const CustomBendExpressions = [
    '$startLengthMin',
    '$startLengthMax',
    '$endLengthMin',
    '$endLengthMax',
    '$minFlangeLength',
    '$middlePoint',
    '$safeZone',
    '$startIndicatorEndX',
    '$startIndicatorEndY',
    '$startIndicatorStartZ',
    '$startIndicatorEndZ',
    '$sizeIndicatorExtrusionX',
    '$sizeIndicatorExtrusionY',
    '$indicatorLabelFontSize',
    '$endIndicatorStartX',
    '$endIndicatorStartY',
    '$endIndicatorEndX',
    '$endIndicatorEndY',
    '$endIndicatorStartZ',
    '$endIndicatorEndZ',
    '$plate'
];
const StrikeBendExpressions = [
    '$middlePoint',
    '$plate'
];
const HoleExpressions = [
    '$sizeX',
    '$sizeY',
    '$sizeTolerance',
    '$minX',
    '$minY',
    '$maxX',
    '$maxY',
    '$polygons',
    '$dimensionIndicatorColor',
    '$innerSize',
    '$absCoords3D',
    '$boundingBox3D',
    '$positionXIndicatorExtrusion',
    '$positionYIndicatorExtrusion',
    '$positionXIndicatorStartX',
    '$positionXIndicatorEndX',
    '$positionXIndicatorStartY',
    '$positionXIndicatorEndY',
    '$positionXIndicatorStartZ',
    '$positionXIndicatorEndZ',
    '$positionXIndicatorExtrusionY',
    '$positionXIndicatorExtrusionZ',
    '$positionIndicatorLabelFontSize',
    '$positionYIndicatorStartX',
    '$positionYIndicatorEndX',
    '$positionYIndicatorStartY',
    '$positionYIndicatorEndY',
    '$positionYIndicatorStartZ',
    '$positionYIndicatorEndZ',
    '$positionYIndicatorExtrusionX',
    '$positionYIndicatorExtrusionZ',
    '$sizeXIndicatorStartX',
    '$sizeXIndicatorEndX',
    '$sizeXIndicatorStartY',
    '$sizeXIndicatorEndY',
    '$sizeXIndicatorStartZ',
    '$sizeXIndicatorEndZ',
    '$sizeXIndicatorExtrusionY',
    '$sizeXIndicatorExtrusionZ',
    '$sizeIndicatorLabelFontSize',
    '$sizeIndicatorColor',
    '$sizeYIndicatorStartX',
    '$sizeYIndicatorEndX',
    '$sizeYIndicatorStartY',
    '$sizeYIndicatorEndY',
    '$sizeYIndicatorStartZ',
    '$sizeYIndicatorEndZ',
    '$sizeYIndicatorExtrusionX',
    '$sizeYIndicatorExtrusionZ',
    '$plate',
    '$anchorPointFrom',
    '$anchorPointTo',
    '$defaultCornerOffset'
];
const KickPlateBulkOrderItemExpressions = [
    '$horizontalLengthMin',
    '$horizontalLengthMax',
    '$verticalLengthMin',
    '$verticalLengthMax',
    '$horizontalHoleCount',
    '$verticalHoleCount',
    '$availableHorizontalHoleCountOptions',
    '$availableVerticalHoleCountOptions',
    '$plate',
    '$violations'
];
const PlateExpressions = [
    '$customMaterials',
    '$selectedCustomMaterial',
    '$cornerRadius',
    '$minimumDistanceHoleToEdge',
    '$sizeX',
    '$sizeY',
    '$sizeX3D',
    '$sizeY3D',
    '$sizeZ3D',
    '$flatSizeX',
    '$flatSizeY',
    '$maxRawSize',
    '$maxRawSizeX',
    '$maxRawSizeY',
    '$maxHorizontalLength',
    '$maxVerticalLength',
    '$maxFeatureSize',
    '$middleZ',
    '$availableFinishes',
    '$availableThicknesses',
    '$hasFinishDirection',
    '$usedCountersinks',
    '$numBends',
    '$numHoles',
    '$availableRawMaterials',
    '$allCountersinks',
    '$availableCountersinks',
    '$featureSettings',
    '$hasCornerHoles',
    '$hasKickPlateHoles',
    '$supportsSingleHoles',
    '$supportsCornerHoles',
    '$supportsKickPlateHoles',
    '$supportsLocksetHoles',
    '$supportsCylinderHoles',
    '$supportsShapeHoles',
    '$overlappingFeatureIds',
    '$overlappingFeatureHotspotIds',
    '$allOverlappingFeatureIds',
    '$activeBend',
    '$bendName',
    '$bendTool',
    '$bendRadius',
    '$bendOrientation',
    '$bendLength',
    '$segmentInfo',
    '$defaultFlatSegmentInfo',
    '$dimensionIndicatorContrastColor',
    '$boltHoleRecipes',
    '$countersinkHoleRecipes',
    '$cylinderHoleRecipes',
    '$locksetHoleRecipes',
    '$shapeHoleRecipes',
    '$sizeXIndicatorFilter',
    '$sizeIndicatorExtrusion',
    '$indicatorLabelFontSize',
    '$sizeYIndicatorFilter',
    '$radiusIndicatorX',
    '$radiusIndicatorY',
    '$radiusIndicatorZ',
    '$radiusIndicatorExtrusion',
    '$radiusIndicatorExtrusionZ',
    '$radiusIndicatorLabel',
    '$allAnchorPoints',
    '$customBend',
    '$holes',
    '$powderCoatingMountingHole',
    '$conflictingFeatureDistance',
    '$powderCoatingMinHoleSize',
    '$minLength'
];
const StrikePlateExpressions = [
    '$minHorizontalLength',
    '$tongueHorizontalLength',
    '$minTongueHorizontalLength',
    '$maxTongueHorizontalLength',
    '$tongueVerticalLength',
    '$tongueOffsetStart',
    '$tongueOffsetEnd',
    '$minTongueOffset',
    '$jointCornerRadius',
    '$bendMeasurements',
    '$maxHorizontalLength',
    '$isTStrikeFilter',
    '$tStrikeMainWidth',
    '$minTStrikeMainWidth',
    '$maxTStrikeMainWidth',
    '$minLength',
    '$maxVerticalLength',
    '$maxMainCornerRadius',
    '$maxTongueOffsetStart',
    '$maxTongueOffsetEnd',
    '$maxTongueCornerRadius',
    '$maxJointCornerRadius',
    '$tongueIndicatorBottomY',
    '$middleZ',
    '$tongueIndicatorExtrusionX',
    '$indicatorLabelFontSize',
    '$tongueIndicatorTopY',
    '$sizeY',
    '$mainIndicatorStartX',
    '$mainIndicatorEndX',
    '$mainIndicatorExtrusion',
    '$tStrikeMainPlusTongueIndicatorStartX',
    '$tStrikeMainPlusTongueIndicatorEndX',
    '$tStrikeMainPlusTongueIndicatorExtrusion',
    '$tongueBend',
    '$violations'
];
const RootEntityExpressions = [
    '$viewControlsFilter'
];
const CornerCountersinkHolesExpressions = [
    '$cornerBoltHolesRecipes',
    '$holeType',
    '$violations'
];
const CornerBoltHolesExpressions = [
    '$cornerCountersinkHolesRecipes',
    '$holeType',
    '$violations'
];
const KickPlateBoltHolesExpressions = [
    '$kickPlateCountersinkHolesRecipes',
    '$holeType',
    '$violations'
];
const KickPlateCountersinkHolesExpressions = [
    '$kickPlateBoltHolesRecipes',
    '$holeType',
    '$violations'
];
const SquarePlateExpressions = [
    '$minSideLength',
    '$maxSideLength',
    '$violations'
];
const RectangularPlateExpressions = [
    '$minHorizontalLength',
    '$maxHorizontalLength',
    '$minVerticalLength',
    '$maxVerticalLength',
    '$violations'
];
const KickPlateExpressions = [
    '$maxHorizontalLength',
    '$maxVerticalLength',
    '$bulkOrderItems',
    '$minHorizontalLength',
    '$minVerticalLength',
    '$violations'
];
const BoltHoleExpressions = [
    '$holeType',
    '$violations'
];
const PlainCylinderHoleExpressions = [
    '$holeType',
    '$violations'
];
const RimCylinderHoleExpressions = [
    '$holeType',
    '$violations'
];
const Hole54Expressions = [
    '$holeType',
    '$violations'
];
const DeadboltHoleExpressions = [
    '$holeType',
    '$violations'
];
const PlainLocksetHoleExpressions = [
    '$holeType',
    '$violations'
];
const CountersinkHoleExpressions = [
    '$holeType',
    '$violations'
];
const CamlockHoleExpressions = [
    '$holeType',
    '$violations'
];
const EuroCylinderHoleAuExpressions = [
    '$holeType',
    '$violations'
];
const EuroCylinderHoleEuExpressions = [
    '$holeType',
    '$violations'
];
const OvalCylinderHoleExpressions = [
    '$holeType',
    '$violations'
];
const PN6HoleExpressions = [
    '$holeType',
    '$violations'
];
const PD7HoleExpressions = [
    '$holeType',
    '$violations'
];
const RectangularHoleExpressions = [
    '$holeType',
    '$violations'
];
const SquareHoleExpressions = [
    '$holeType',
    '$violations'
];
const RoundPlateExpressions = [
    '$violations'
];
export const $KickPlate = new $DomainEntityReflection('KickPlate', [
    ...KickPlateExpressions,
    ...PlateExpressions,
    ...RootEntityExpressions,
    ...AnchorableShapeExpressions
]);
export const $RectangularPlate = new $DomainEntityReflection('RectangularPlate', [
    ...RectangularPlateExpressions,
    ...PlateExpressions,
    ...RootEntityExpressions,
    ...AnchorableShapeExpressions
]);
export const $RoundPlate = new $DomainEntityReflection('RoundPlate', [
    ...RoundPlateExpressions,
    ...PlateExpressions,
    ...RootEntityExpressions,
    ...AnchorableShapeExpressions
]);
export const $SquarePlate = new $DomainEntityReflection('SquarePlate', [
    ...SquarePlateExpressions,
    ...PlateExpressions,
    ...RootEntityExpressions,
    ...AnchorableShapeExpressions
]);
export const $StrikePlate = new $DomainEntityReflection('StrikePlate', [
    ...StrikePlateExpressions,
    ...PlateExpressions,
    ...RootEntityExpressions,
    ...AnchorableShapeExpressions
]);
export const $BoltHole = new $DomainEntityReflection('BoltHole', [
    ...BoltHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $PlainCylinderHole = new $DomainEntityReflection('PlainCylinderHole', [
    ...PlainCylinderHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $RimCylinderHole = new $DomainEntityReflection('RimCylinderHole', [
    ...RimCylinderHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $Hole54 = new $DomainEntityReflection('Hole54', [
    ...Hole54Expressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $DeadboltHole = new $DomainEntityReflection('DeadboltHole', [
    ...DeadboltHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $PlainLocksetHole = new $DomainEntityReflection('PlainLocksetHole', [
    ...PlainLocksetHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $CornerBoltHoles = new $DomainEntityReflection('CornerBoltHoles', [
    ...CornerBoltHolesExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $CornerCountersinkHoles = new $DomainEntityReflection('CornerCountersinkHoles', [
    ...CornerCountersinkHolesExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $KickPlateBoltHoles = new $DomainEntityReflection('KickPlateBoltHoles', [
    ...KickPlateBoltHolesExpressions,
    ...KickPlateFixingHolesExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $KickPlateCountersinkHoles = new $DomainEntityReflection('KickPlateCountersinkHoles', [
    ...KickPlateCountersinkHolesExpressions,
    ...KickPlateFixingHolesExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $CountersinkHole = new $DomainEntityReflection('CountersinkHole', [
    ...CountersinkHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $CamlockHole = new $DomainEntityReflection('CamlockHole', [
    ...CamlockHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $EuroCylinderHoleAu = new $DomainEntityReflection('EuroCylinderHoleAu', [
    ...EuroCylinderHoleAuExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $EuroCylinderHoleEu = new $DomainEntityReflection('EuroCylinderHoleEu', [
    ...EuroCylinderHoleEuExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $OvalCylinderHole = new $DomainEntityReflection('OvalCylinderHole', [
    ...OvalCylinderHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $PN6Hole = new $DomainEntityReflection('PN6Hole', [
    ...PN6HoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $PD7Hole = new $DomainEntityReflection('PD7Hole', [
    ...PD7HoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $RectangularHole = new $DomainEntityReflection('RectangularHole', [
    ...RectangularHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $SquareHole = new $DomainEntityReflection('SquareHole', [
    ...SquareHoleExpressions,
    ...HoleExpressions,
    ...AnchorableShapeExpressions
]);
export const $CustomBend = new $DomainEntityReflection('CustomBend', [
    ...CustomBendExpressions
]);
export const $StrikeBend = new $DomainEntityReflection('StrikeBend', [
    ...StrikeBendExpressions,
    ...AnchorableShapeExpressions
]);
export const $AnchorPoint = new $DomainEntityReflection('AnchorPoint', [
    ...AnchorPointExpressions
]);
export const $KickPlateBulkOrderItem = new $DomainEntityReflection('KickPlateBulkOrderItem', [
    ...KickPlateBulkOrderItemExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    KickPlate.type,
    RectangularPlate.type,
    RoundPlate.type,
    SquarePlate.type,
    StrikePlate.type,
    BoltHole.type,
    PlainCylinderHole.type,
    RimCylinderHole.type,
    Hole54.type,
    DeadboltHole.type,
    PlainLocksetHole.type,
    CornerBoltHoles.type,
    CornerCountersinkHoles.type,
    KickPlateBoltHoles.type,
    KickPlateCountersinkHoles.type,
    CountersinkHole.type,
    CamlockHole.type,
    EuroCylinderHoleAu.type,
    EuroCylinderHoleEu.type,
    OvalCylinderHole.type,
    PN6Hole.type,
    PD7Hole.type,
    RectangularHole.type,
    SquareHole.type,
    CustomBend.type,
    StrikeBend.type,
    AnchorPoint.type,
    KickPlateBulkOrderItem.type
]);
export const $BasePlate = new EnhancedAliasReflection('$BasePlate', [
    KickPlate.type,
    RectangularPlate.type,
    RoundPlate.type,
    SquarePlate.type,
    StrikePlate.type
]);
export const $BendablePlate = new EnhancedAliasReflection('$BendablePlate', [
    RectangularPlate.type,
    SquarePlate.type
]);
export const $Plate = new EnhancedAliasReflection('$Plate', [
    ...BendablePlate.types,
    RoundPlate.type,
    KickPlate.type,
    StrikePlate.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    ...Plate.types
]);
export const $FixingHole = new EnhancedAliasReflection('$FixingHole', [
    CornerBoltHoles.type,
    BoltHole.type,
    CountersinkHole.type,
    CornerCountersinkHoles.type,
    KickPlateBoltHoles.type,
    KickPlateCountersinkHoles.type
]);
export const $AnyBoltHole = new EnhancedAliasReflection('$AnyBoltHole', [
    CornerBoltHoles.type,
    BoltHole.type,
    KickPlateBoltHoles.type
]);
export const $AnyCountersinkHole = new EnhancedAliasReflection('$AnyCountersinkHole', [
    CountersinkHole.type,
    CornerCountersinkHoles.type,
    KickPlateCountersinkHoles.type
]);
export const $SingleFixingHole = new EnhancedAliasReflection('$SingleFixingHole', [
    BoltHole.type,
    CountersinkHole.type
]);
export const $CornerFixingHoles = new EnhancedAliasReflection('$CornerFixingHoles', [
    CornerBoltHoles.type,
    CornerCountersinkHoles.type
]);
export const $KickPlateFixingHoles = new EnhancedAliasReflection('$KickPlateFixingHoles', [
    KickPlateBoltHoles.type,
    KickPlateCountersinkHoles.type
]);
export const $CircularHole = new EnhancedAliasReflection('$CircularHole', [
    CornerBoltHoles.type,
    BoltHole.type,
    KickPlateBoltHoles.type,
    PlainCylinderHole.type,
    RimCylinderHole.type,
    Hole54.type,
    DeadboltHole.type,
    PlainLocksetHole.type
]);
export const $EuroCylinderHole = new EnhancedAliasReflection('$EuroCylinderHole', [
    EuroCylinderHoleEu.type,
    EuroCylinderHoleAu.type
]);
export const $CylinderHole = new EnhancedAliasReflection('$CylinderHole', [
    OvalCylinderHole.type,
    RimCylinderHole.type,
    EuroCylinderHoleAu.type,
    EuroCylinderHoleEu.type,
    CamlockHole.type,
    PlainCylinderHole.type
]);
export const $LocksetHole = new EnhancedAliasReflection('$LocksetHole', [
    Hole54.type,
    PD7Hole.type,
    PN6Hole.type,
    DeadboltHole.type,
    PlainLocksetHole.type
]);
export const $ShapeHole = new EnhancedAliasReflection('$ShapeHole', [
    RectangularHole.type,
    SquareHole.type
]);
export const $Hole = new EnhancedAliasReflection('$Hole', [
    CountersinkHole.type,
    CornerCountersinkHoles.type,
    KickPlateCountersinkHoles.type,
    CornerBoltHoles.type,
    BoltHole.type,
    KickPlateBoltHoles.type,
    PlainCylinderHole.type,
    RimCylinderHole.type,
    Hole54.type,
    DeadboltHole.type,
    PlainLocksetHole.type,
    CamlockHole.type,
    EuroCylinderHoleEu.type,
    EuroCylinderHoleAu.type,
    OvalCylinderHole.type,
    PN6Hole.type,
    PD7Hole.type,
    RectangularHole.type,
    SquareHole.type
]);
export const $Feature = new EnhancedAliasReflection('$Feature', [
    ...Hole.types,
    CustomBend.type
]);
export const $AnchorableShape = new EnhancedAliasReflection('$AnchorableShape', [
    ...Plate.types,
    ...Hole.types,
    StrikeBend.type
]);
export const $entityReflections = {
    KickPlate: $KickPlate,
    RectangularPlate: $RectangularPlate,
    RoundPlate: $RoundPlate,
    SquarePlate: $SquarePlate,
    StrikePlate: $StrikePlate,
    BoltHole: $BoltHole,
    PlainCylinderHole: $PlainCylinderHole,
    RimCylinderHole: $RimCylinderHole,
    Hole54: $Hole54,
    DeadboltHole: $DeadboltHole,
    PlainLocksetHole: $PlainLocksetHole,
    CornerBoltHoles: $CornerBoltHoles,
    CornerCountersinkHoles: $CornerCountersinkHoles,
    KickPlateBoltHoles: $KickPlateBoltHoles,
    KickPlateCountersinkHoles: $KickPlateCountersinkHoles,
    CountersinkHole: $CountersinkHole,
    CamlockHole: $CamlockHole,
    EuroCylinderHoleAu: $EuroCylinderHoleAu,
    EuroCylinderHoleEu: $EuroCylinderHoleEu,
    OvalCylinderHole: $OvalCylinderHole,
    PN6Hole: $PN6Hole,
    PD7Hole: $PD7Hole,
    RectangularHole: $RectangularHole,
    SquareHole: $SquareHole,
    CustomBend: $CustomBend,
    StrikeBend: $StrikeBend,
    AnchorPoint: $AnchorPoint,
    KickPlateBulkOrderItem: $KickPlateBulkOrderItem
};

//# sourceMappingURL=enhanced-model.js.map